import $ from 'jquery';
import { localize } from '../../compat/core';

const Resx = localize('App', 'Common');

export default function () {
    $('input.spectrum-color-picker').each(function () {
        $(this).spectrum({
            preferredFormat: "hex",
            chooseText: Resx.Common && Resx.Common.Choose,
            cancelText: Resx.Common && Resx.Common.Cancel,
            showInput: true
        });
    });
}